export default "__VITE_ASSET__BxWlEvk4__"